'use strict';
var GEO_DATA, Geocoder, KeywordBar, Location, LocationBar, LocationError, Typeahead, breakDownAddress, detectCurrentLocation, getGeoSearchOverrideUrl, getLocationForSearch, getLocationOverrideUrl, getSearchOverrideUrl, getSearchUrl, isBlank, locationHasChanged, myPlaces, omit, pick, placeholderState, redirectToUrl, ref, ref1, removeGeolocationData, saveRecentSearch, setSiteCookies, storeGeolocationData, storeLocationData, trackEvent,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

KeywordBar = require('../helper/search/view/m_keyword_bar');

Location = require('../helper/search/helper/m_location_helper');

LocationBar = require('../helper/search/view/m_location_bar');

LocationError = require('../helper/search/view/m_error');

Typeahead = require('../helper/search/view/m_typeahead');

Geocoder = require('../helper/search/common/m_geocoder');

setSiteCookies = require('../helper/general/m_setSiteCookies');

redirectToUrl = require('../helper/general/m_setWindowLocation');

trackEvent = require('../helper/general/m_trackEvent');

isBlank = require('../../../core/frontend/common/underscore_mixins').isBlank;

ref = require('../helper/general/m_underscore_replacements'), pick = ref.pick, omit = ref.omit;

ref1 = require('../helper/search/helper/m_searchbar_helper'), breakDownAddress = ref1.breakDownAddress, getGeoSearchOverrideUrl = ref1.getGeoSearchOverrideUrl, getLocationForSearch = ref1.getLocationForSearch, getLocationOverrideUrl = ref1.getLocationOverrideUrl, getSearchOverrideUrl = ref1.getSearchOverrideUrl, getSearchUrl = ref1.getSearchUrl, GEO_DATA = ref1.GEO_DATA, removeGeolocationData = ref1.removeGeolocationData, storeGeolocationData = ref1.storeGeolocationData, storeLocationData = ref1.storeLocationData;

saveRecentSearch = require('../helper/search/helper/m_typeahead_helper.coffee').saveRecentSearch;

detectCurrentLocation = require('../helper/search/helper/m_detectCurrentLocation').detectCurrentLocation;

placeholderState = require('../helper/search/helper/m_common').placeholderState;

myPlaces = require('../../../modules/my_places/frontend/myplaces_widget');

locationHasChanged = void 0;

module.exports = (function() {
  var keyword, translations;

  keyword = translations = void 0;

  function _Class() {
    this._redirectTo = bind(this._redirectTo, this);
    this._geocoderError = bind(this._geocoderError, this);
    this._geocoderSuccess = bind(this._geocoderSuccess, this);
    this._searchWithPlaces = bind(this._searchWithPlaces, this);
    this._searchWithAutocomplete = bind(this._searchWithAutocomplete, this);
    this._searchWithGmaps = bind(this._searchWithGmaps, this);
    this._searchWithGeolocation = bind(this._searchWithGeolocation, this);
    this._cleanGeolocationTraces = bind(this._cleanGeolocationTraces, this);
    this._gatherData = bind(this._gatherData, this);
    this._getQuery = bind(this._getQuery, this);
    this.setSearchbarFocusTracking = bind(this.setSearchbarFocusTracking, this);
    this.onFormSubmit = bind(this.onFormSubmit, this);
  }

  _Class.prototype.init = function(opts) {
    var elements, name, ref2, selector;
    elements = opts.elements, this.env = opts.env, this.options = opts.options;
    for (name in elements) {
      selector = elements[name];
      this['$' + name] = $(selector);
    }
    this.$inputs = (ref2 = this.$search) != null ? ref2.add(this.$location) : void 0;
    this.useLocationPlacesAPI = false;
    this.enableMyPlaces = false;
    this.setCommonExperiments();
    if (typeof this.setExperiments === "function") {
      this.setExperiments();
    }
    this.render(this.options);
    this.bindFormSubmit();
    this.bindDefault();
    if (typeof this.bind === "function") {
      this.bind();
    }
    this.country = I18n.country;
    translations = opts.translations || Groupon.LS.translations || {};
    this.geolocationData = Location.getGeolocationData();
  };

  _Class.prototype.setCommonExperiments = function() {
    return Finch.experiment('LS-2614-MyPlaces_relevance', {
      Treatment: (function(_this) {
        return function() {
          return _this.enableMyPlaces = true;
        };
      })(this)
    });
  };


  /*
   * Bind form submit handler
   */

  _Class.prototype.bindFormSubmit = function() {
    return this.$form.on('submit', (function(_this) {
      return function(e) {
        return _this.onFormSubmit(e);
      };
    })(this));
  };

  _Class.prototype.bindDefault = function() {

    /*
     * Input events
     */
    this.$inputs.on('input focusin', (function(_this) {
      return function(e) {
        var el;
        el = e.currentTarget;
        placeholderState.toggle($(el));
        e.preventDefault();
        return _this.typeahead.buildAutocompleteListThrottle(_.clone(e), el.name);
      };
    })(this));

    /*
     * Typeahead events
     */
    this.$resultList.on('click', 'a', (function(_this) {
      return function(e) {
        var $trigger, ref2;
        if (e != null ? (ref2 = e.currentTarget) != null ? ref2.href : void 0 : void 0) {
          return;
        }
        $trigger = $(e.currentTarget);
        e.preventDefault();
        return _this.selectAndFill($trigger);
      };
    })(this));
    return $(window).one('load', (function(_this) {
      return function() {
        return _this.$form.find('input').each(function() {
          return placeholderState.toggle($(this));
        });
      };
    })(this));
  };

  _Class.prototype.selectAndFillWithoutSubmit = function($trigger) {
    var $widget, source;
    $widget = this.$resultList;
    $widget.find('.typeahead-match').removeClass('typeahead-match');
    if ($widget.hasClass('typeahead-location')) {
      source = 'location';
      this._updateValueAndLatLng($trigger, this.$location);
    } else {
      source = 'deal';
      this._updateValue($trigger, this.$search);
    }
    return source;
  };


  /**
   * Autocomplete link handler
   * Updates deal or location input
   *
   * @param {Object} e - jQuery event
   */

  _Class.prototype.selectAndFill = function($trigger) {
    this.selectAndFillWithoutSubmit($trigger);
    this.$form.trigger('submit');
  };

  _Class.prototype.render = function(opts) {
    var experiments, flags, options, ref2, ref3, ref4;
    ref2 = Groupon.LS, options = ref2.options, experiments = ref2.experiments, flags = ref2.flags;
    if (options == null) {
      options = {};
    }
    options = Object.assign({}, options, experiments, flags, opts, {
      fetchWithPlacesApi: this.useLocationPlacesAPI,
      enableMyPlaces: this.enableMyPlaces
    });
    this.typeahead = new Typeahead({
      env: this.env,
      resultList: this.$resultList,
      endpoints: {
        search: (ref3 = Groupon.endpoints) != null ? ref3.deals : void 0,
        location: (ref4 = Groupon.endpoints) != null ? ref4.locations : void 0
      },
      options: options,
      experiments: experiments
    });
    if (this.enableMyPlaces) {
      myPlaces.init(this.typeahead, this.myPlacesModal);
    }
    if (this.$search != null) {
      this.keywordBar = new KeywordBar({
        $form: this.$form,
        env: this.env
      });
    }
    if (this.$location != null) {
      this.locationError = new LocationError({
        $form: this.$form,
        env: this.env,
        $resultList: this.$resultList,
        enableBetterUx: options.enableBetterUx
      });
      this.locationBar = new LocationBar({
        $form: this.$form,
        env: this.env
      });
    }
    return this.setSearchbarFocusTracking();
  };

  _Class.prototype.onFormSubmit = function(e) {
    var data, fn, overrideUrl, ref2, state;
    e.preventDefault();
    state = this.locationState;
    ref2 = this._gatherData(state), data = ref2.data, state = ref2.state;
    if (data == null) {
      return;
    }
    if (typeof this.lockSubmit === "function") {
      this.lockSubmit(true);
    }
    overrideUrl = getGeoSearchOverrideUrl(data.query, data.address);
    if (overrideUrl != null) {
      return redirectToUrl(overrideUrl);
    }
    locationHasChanged = true;
    switch (state) {
      case 'geolocate':
        data.currentLocation = true;
        locationHasChanged = false;
        fn = this._searchWithGeolocation;
        break;
      case 'autocomplete':
        fn = this._searchWithAutocomplete;
        Location.removeGeolocationData('current_location');
        if (this.useLocationPlacesAPI && data.place_id) {
          fn = this._searchWithPlaces;
        }
        break;
      case 'manual':
        fn = this._searchWithGmaps;
        Location.removeGeolocationData('current_location');
        break;
      default:
        locationHasChanged = false;
        fn = this._redirectTo;
    }
    return (fn.bind(this))(data);
  };

  _Class.prototype.setSearchbarFocusTracking = function() {
    return this.$form.on('focusin.searchbar', (function(_this) {
      return function(e) {
        if (e.target && $(e.currentTarget).find(e.target).length) {
          trackEvent('searchbar-focusin');
          _this.$form.off('focusin.searchbar');
          return _this.$form.on('focusout.searchbar', function(event) {
            if (!$(event.currentTarget).find(event.relatedTarget).length) {
              trackEvent('searchbar-focusout');
              _this.$form.off('focusout.searchbar');
              return _this.setSearchbarFocusTracking();
            }
          });
        }
      };
    })(this));
  };


  /*
   * ------------------
   * PRIVATE NON-PUBLIC
   * ------------------
   */


  /**
   * Set location data to location input from autocomplete item
   *
   * @param {Object} $trigger - jQuery object of autocomplete item
   */

  _Class.prototype._updateValueAndLatLng = function($source, $target) {
    var data, division, lat, lng, place_id, ref2, value;
    ref2 = $source.data(), value = ref2.value, lat = ref2.lat, lng = ref2.lng, division = ref2.division, place_id = ref2.place_id;
    if ($source.hasClass('current-location')) {
      this.locationState = 'geolocate';
      value = translations.search.nearme;
      data = {
        current_location: true,
        manual: false,
        value: value
      };
    } else {
      this.locationState = 'autocomplete';
      data = this.useLocationPlacesAPI && place_id ? {
        place_id: place_id,
        'manual': false,
        value: value
      } : {
        lat: lat.toString(),
        lng: lng.toString(),
        division: division,
        'manual': false,
        value: value
      };
    }
    $target.val(value).data(data);
  };


  /**
   * Write deal data to deal input from autocomplete item
   *
   * @param {Object} $source - jQuery object of autocomplete item
   */

  _Class.prototype._updateValue = function($source, $target) {
    if ($source == null) {
      $source = {};
    }
    if ($target == null) {
      $target = {};
    }
    placeholderState.set($target, 'hide');
    $target.val($source.data('value'));
  };

  _Class.prototype._getQuery = function() {
    var maxChars, ref2, ref3;
    maxChars = this.$search.attr('maxlength') || 50;
    keyword = (ref2 = this.keywordBar) != null ? (ref3 = ref2.val()) != null ? ref3.trim().slice(0, maxChars) : void 0 : void 0;
    if (!isBlank(keyword)) {
      return keyword;
    }
  };

  _Class.prototype._pickLocationData = function(data, withGEO) {
    var paths;
    if (withGEO == null) {
      withGEO = false;
    }
    paths = ['lat', 'lng', 'closestDivision', 'division', 'place_id'];
    if (withGEO) {
      paths = paths.concat(GEO_DATA);
    }
    return pick(data, paths);
  };

  _Class.prototype._gatherData = function(state) {
    var data, dealSearch, geoMaximumAge, geolocationData, locData, locSearch, locationMatch, ref2, ref3, ref4;
    geolocationData = (ref2 = this.geolocationData) != null ? ref2.current_location : void 0;
    dealSearch = this._getQuery();
    locSearch = this.locationBar.val();
    data = null;
    if (!dealSearch && !locSearch) {
      return {
        state: state,
        data: data
      };
    }
    if (dealSearch != null) {
      saveRecentSearch(dealSearch, 'deal');
    }
    if ((locationMatch = $('.typeahead-location .typeahead-match')).length) {
      if (state == null) {
        state = 'autocomplete';
      }
      data = this._pickLocationData(locationMatch.data());
    } else {
      locData = this.$location.data();
      if (locData.manual && state === void 0) {
        state = 'manual';
      }
      if (locData.value && locData.value !== locSearch) {
        state = 'manual';
      }
      switch (state) {
        case 'autocomplete':
        case 'manual':
          data = this._pickLocationData(locData);
          break;
        default:
          data = this._pickLocationData(locData, true);
          geoMaximumAge = (ref3 = Groupon.Modules.SearchBar.geolocationOptions) != null ? ref3.maximumAge : void 0;
          if (geoMaximumAge && Date.now() - (geolocationData != null ? geolocationData.timeStamp : void 0) > geoMaximumAge) {
            state = 'geolocate';
          }
      }
    }
    if (!geolocationData || !data.closestDivision) {
      data.closestDivision = (ref4 = Groupon.division) != null ? ref4.id : void 0;
    }
    return {
      data: Object.assign(data, {
        address: locSearch,
        query: keyword
      }),
      state: state
    };
  };

  _Class.prototype._cleanGeolocationTraces = function() {
    var data, lat, lng, name, options;
    Location.removeGeolocationData('current_location');
    Location.setGeolocationData('geoLocationGranted', false);
    if (translations.search.currentlocation === this.$location.val() && ((data = Groupon.division) != null)) {
      lat = data.lat, lng = data.lng, name = data.name;
      options = {
        address: name,
        lat: lat,
        lng: lng,
        geocoderSuccess: (function(_this) {
          return function(arg) {
            var locationData;
            locationData = arg.locationData;
            _this.$location.data(locationData).val(locationData.friendlyName);
            return Location.setSearchLocCookie(locationData);
          };
        })(this),
        geocoderError: function() {}
      };
      return this._searchWithGmaps(options);
    }
  };


  /**
   * HTML5 geolocation handler to get latitude and longitude
   * and perform geocoder lookup via Google Maps
   *
   * @param {Object} data
   */

  _Class.prototype._searchWithGeolocation = function(data) {
    var geoLocationError, geolocationSuccess, query;
    if (data == null) {
      query = this._getQuery();
      data = {
        address: translations.search.nearme,
        query: query
      };
    }
    if (this.env === 'desktop') {
      $('.typeahead-response.location').hide();
    }
    geolocationSuccess = (function(_this) {
      return function(arg) {
        var lat, lng;
        lat = arg.lat, lng = arg.lng;
        _this.$location.val(data.address);
        data = Object.assign(data, {
          lat: lat,
          lng: lng,
          current_location: true
        });
        trackEvent('location-bar-geolocation-success', {
          lat: lat,
          lng: lng
        });
        Location.setGeolocationData('geoLocationGranted', true);
        return _this._searchWithAutocomplete(data);
      };
    })(this);
    geoLocationError = (function(_this) {
      return function(err) {
        _this._cleanGeolocationTraces();
        trackEvent('location-bar-geolocation-error', err);
        _this.locationError.displayAvailabilityError('current-location');
        return typeof _this.lockSubmit === "function" ? _this.lockSubmit(false) : void 0;
      };
    })(this);
    return detectCurrentLocation(geolocationSuccess, geoLocationError);
  };


  /**
   * Google Maps handler for geocoder lookup
   *
   * @param {Object} [options] - Location data
   */

  _Class.prototype._searchWithGmaps = function(options) {
    var address, current_location, geocoderError, geocoderSuccess, lat, lng;
    if (options == null) {
      options = {};
    }
    address = options.address, current_location = options.current_location, lat = options.lat, lng = options.lng, geocoderSuccess = options.geocoderSuccess, geocoderError = options.geocoderError;
    options = {
      address: address,
      location: {
        lat: lat,
        lng: lng
      },
      current_location: current_location,
      country: this.country,
      geocoderSuccess: geocoderSuccess,
      geocoderError: geocoderError
    };
    if (!(geocoderSuccess || geocoderError)) {
      options = Object.assign({}, options, {
        geocoderSuccess: this._geocoderSuccess.bind(this),
        geocoderError: this._geocoderError.bind(this)
      });
    }
    if (!this.geocoder) {
      this.geocoder = new Geocoder();
    }
    return this.geocoder.geocode(options);
  };


  /**
   * Location autocomplete handler
   * Uses data to directly redirect or do closestDivision lookup
   *
   * @param {Object} data - Location data
   */

  _Class.prototype._searchWithAutocomplete = function(data) {
    var address, locationData, query;
    address = data.address, query = data.query;
    trackEvent('location-bar-autocomplete-successful-match', {
      query: query,
      address: address
    });
    if (this.country === 'US') {
      data = breakDownAddress(data);
    }
    if (data.division) {
      locationData = Object.assign(data, data.geocoderData);
      delete locationData.geocoderData;
      data.closestDivision = data.division;
      return this._geocoderSuccess({
        address: data.address,
        locationData: locationData
      });
    }
    data = Object.assign({}, data, {
      geocoderSuccess: this._geocoderSuccess.bind(this),
      geocoderError: this._geocoderError.bind(this)
    });
    new Geocoder().fetchClosestDivision(data);
  };


  /**
   * LS-3106 search with Places API proxy and getClosestDivision
   *
   * @param {Object} placesData
   */

  _Class.prototype._searchWithPlaces = function(placesData) {
    var address, ajaxConfig, error, place_id, query, ref2;
    address = placesData.address, query = placesData.query, place_id = placesData.place_id;
    trackEvent('location-bar-places-successful-match', placesData);
    error = (function(_this) {
      return function(err) {
        return _this._geocoderError({
          address: address,
          status: 'UNAVAILABLE',
          data: err
        });
      };
    })(this);
    ajaxConfig = {
      url: [(ref2 = Groupon.endpoints) != null ? ref2.places_details : void 0, 'v1'].join('/'),
      data: {
        place_id: place_id
      },
      headers: {
        'x-ls-locale': I18n.locale
      },
      success: (function(_this) {
        return function(arg) {
          var data, err;
          data = arg.data, err = arg.err;
          if (err) {
            return error(err);
          }
          return (_this._geocoderSuccess.bind(_this))({
            query: query,
            address: address,
            locationData: Object.assign(data, {
              locationId: place_id,
              fullAddress: address || data.fullAddress
            }),
            current_location: false
          });
        };
      })(this),
      error: error
    };
    $.ajax(ajaxConfig);
  };

  _Class.prototype._geocoderSuccess = function(arg) {
    var address, currentLocationData, current_location, data, hasLocCookie, locationData, query, trackyEventName;
    address = arg.address, query = arg.query, locationData = arg.locationData, current_location = arg.current_location;
    Location.setELLCookie(locationData.lat + ',' + locationData.lng);
    if (query == null) {
      query = keyword;
    }
    if (locationData.fullAddress != null) {
      address = locationData.fullAddress;
    }
    trackyEventName = 'location-bar-geocode-search-success';
    if (current_location) {
      address = translations.search.nearme;
      trackyEventName = 'location-bar-geolocation-search-success';
      currentLocationData = pick(locationData, 'lat', 'lng', 'closestDivision', 'division', 'address');
      currentLocationData = Object.assign(currentLocationData, {
        timeStamp: new Date().getTime()
      });
      storeGeolocationData(current_location, currentLocationData);
    } else {
      removeGeolocationData();
    }
    locationData.address = locationData.friendlyName = address;
    Location.setSearchLocCookie(locationData);
    hasLocCookie = true;
    trackEvent(trackyEventName, {
      address: address,
      locationData: locationData,
      query: query
    });
    if ((data = locationData || getLocationForSearch())) {
      data = omit(data, ['fullAddress', 'friendlyName', 'types']);
      data = Object.assign(data, {
        query: query
      });
      if (this.enableMyPlaces) {
        myPlaces.setPromptCookie(data.address || data.fullAddress);
      }
      return this._redirectTo(data, hasLocCookie);
    }
  };

  _Class.prototype._geocoderError = function(arg) {
    var address, data, status;
    address = arg.address, status = arg.status, data = arg.data;
    if (typeof this.lockSubmit === "function") {
      this.lockSubmit(false);
    }
    if (status === 'ABORT') {
      return;
    }
    if (status === 'BAD_LOCATION') {
      this.locationError.displayBadLocationError(address);
    } else if (status === 'UNAVAILABLE') {
      this.locationError.displayAvailabilityError(address);
    }
    return trackEvent('location-bar-geocode-search-error', {
      address: address,
      data: data
    });
  };

  _Class.prototype._redirectTo = function(data, hasLocCookie) {
    var address, closestDivision, division, newUrl, query, searchEvent;
    closestDivision = data.closestDivision, division = data.division;
    if (!((closestDivision != null) || (division != null))) {
      if (typeof this.lockSubmit === "function") {
        this.lockSubmit(false);
      }
      return;
    }
    if (closestDivision && !division) {
      data.division = division = closestDivision;
    }
    setSiteCookies({
      division: division
    });
    if (locationHasChanged) {
      storeLocationData(data);
    }
    address = data.address, query = data.query;
    searchEvent = query ? hasLocCookie ? 'deal-search-with-loc-cookie' : 'deal-search-with-no-loc-cookie' : 'location-search';
    trackEvent(searchEvent, {
      address: address,
      query: query
    });
    newUrl = getLocationOverrideUrl(data) || getSearchOverrideUrl(division, data, this.env === 'mobile') || getSearchUrl(division, omit(data, 'closestDivision'));
    redirectToUrl(newUrl);
  };

  return _Class;

})();

